export default __webpack_public_path__ + "static/media/orage.1fada063.mp3";